import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { type V1GetJobPostingsByProgressStatusViewResponse } from 'mnvm-mypage-app-ts-if'
import { viewServiceApi } from '@/api/view-service-api'

export const getJobPostingProgressStatus =
  async (): Promise<V1GetJobPostingsByProgressStatusViewResponse> => {
    return await viewServiceApi.viewServiceGetJobPostingsByProgressStatusView(
      {}
    )
  }

export const useJobPostingProgressStatus = (): UseQueryResult<
  V1GetJobPostingsByProgressStatusViewResponse,
  unknown
> => {
  return useQuery({
    queryKey: ['job_postings_by_progress_status'],
    queryFn: async () => await getJobPostingProgressStatus()
  })
}
